/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, April 23rd 2022, 9:38:09 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder, Many2ManyIntPKBaseSchema, Many2OneUUIDPKBaseSchema } from "lib/validation";
import { WritableModel } from "lib/schemas/abstract";
import { User, Organization } from "lib/schemas";
import { UUID4, PrimaryKeyValue } from "lib/types";

export interface Team extends WritableModel<true> {
  permissions: number[];
  members: (PrimaryKeyValue<User> & number)[];
  team_name: string;
  readonly group: number;
  organization: PrimaryKeyValue<Organization> & UUID4;
  readonly organization_name?: string;
}

type WriteOnlyTeam = Omit<Team, "id" | "group" | "organization_name">;

export const TeamValidationSchema: schemaBuilder.SchemaOf<WriteOnlyTeam> = schemaBuilder.object().shape({
  team_name: schemaBuilder.string().required("Team name is required."),
  organization: Many2OneUUIDPKBaseSchema().required("Organization is required for a team."),
  members: Many2ManyIntPKBaseSchema().optional().nullable(),
  permissions: Many2ManyIntPKBaseSchema().optional().nullable(),
});
